import { MockedProvider as ApolloMockedProvider } from "@apollo/client/testing";
import { Props } from "./MockedProvider.types";

export const MockedProvider: FC<Props> = ({ children }) => {
  return (
    <ApolloMockedProvider addTypename={false}>{children}</ApolloMockedProvider>
  );
};
